import React from 'react';
import './Banner.css';
import { images } from '../../assets/images';

function Banner() {
  return (
    <div className="knorr-banner">
      <img 
        src= {images.knorrBanner} 
        alt="Ramadan Recipe Builder" 
        className="banner-image"
      />
    </div>
  );
}

export default Banner;
